export default __webpack_public_path__ + "images/27_2_image.jpg";